import React, { useMemo } from 'react';

import { Text } from 'ui/Typography';

import { Sankey } from '../../generated-api';
import { useCurrentUser } from '../../utils/user';
import { useTimeAgo } from '../SankeyBreadcrumb/SaveInfo/utils';

type Props = {
  sankey: Sankey;
};

const DiagramCreatedInfo: React.FC<Props> = ({ sankey }) => {
  const { user } = useCurrentUser();
  const createdAgo = useTimeAgo(sankey.created_at);

  // Get the display name of the user who created the diagram (skip if it's the current user)
  const createdByInfo = useMemo(
    () =>
      user?.id !== sankey.owner_id
        ? user?.default_team?.members.find((m) => m.user_id === sankey.owner_id)
            ?.display_name
        : undefined,
    [user]
  );

  return (
    <Text color="gray.600" fontSize="xs" truncate>
      Created {createdAgo}
      {createdByInfo ? ` by ${createdByInfo}` : ''}
    </Text>
  );
};

export default DiagramCreatedInfo;
